import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    ref: "btn",
    class: _normalizeClass(["shutter", { active: _ctx.isActive, pressed: _ctx.isPressed }]),
    "aria-label": "Сделать снимок",
    type: "button",
    onPointerdown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPointerDown && _ctx.onPointerDown(...args))),
    onPointerup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPointerUp && _ctx.onPointerUp(...args))),
    onPointercancel: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPointerCancel && _ctx.onPointerCancel(...args))),
    onPointerleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPointerCancel && _ctx.onPointerCancel(...args))),
    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.emitCapture && _ctx.emitCapture(...args))),
    onKeydown: [
      _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args)), ["prevent"]), ["space"])),
      _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args)), ["prevent"]), ["enter"]))
    ]
  }, [
    _cache[7] || (_cache[7] = _createElementVNode("span", {
      class: "ring",
      "aria-hidden": "true"
    }, null, -1)),
    _cache[8] || (_cache[8] = _createElementVNode("span", {
      class: "inner",
      "aria-hidden": "true"
    }, null, -1)),
    (_ctx.ripple.visible)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "ripple",
          style: _normalizeStyle(_ctx.ripple.style)
        }, null, 4))
      : _createCommentVNode("", true)
  ], 34))
}